import { isObjectType, isInterfaceType } from 'graphql';
import { CriticalityLevel, ChangeType } from './../changes/change';
import { parsePath } from '../common/path';
export const suppressRemovalOfDeprecatedField = ({ changes, oldSchema, }) => {
    return changes.map((change) => {
        if (change.type === ChangeType.FieldRemoved &&
            change.criticality.level === CriticalityLevel.Breaking &&
            change.path) {
            const [typeName, fieldName] = parsePath(change.path);
            const type = oldSchema.getType(typeName);
            if (isObjectType(type) || isInterfaceType(type)) {
                const field = type.getFields()[fieldName];
                if (field.isDeprecated) {
                    return Object.assign(Object.assign({}, change), { criticality: Object.assign(Object.assign({}, change.criticality), { level: CriticalityLevel.Dangerous }) });
                }
            }
        }
        return change;
    });
};
//# sourceMappingURL=suppress-removal-of-deprecated-field.js.map